import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { PrintQrCodeListData } from 'src/app/shared/models/print';
import { AbstractPrintComponent } from '../abstract-print/abstract-print.component';
import { SyncService } from 'src/app/shared/services/sync.service';
import { RequestService } from 'src/app/shared/services/request.service';
import {environment} from 'src/environments/environment';

@Component({
  selector: 'app-print-qr-list',
  templateUrl: './print-qr-list.component.html',
  styleUrl: './print-qr-list.component.scss'
})
export class PrintQrListComponent extends AbstractPrintComponent {
  @Input() data: PrintQrCodeListData;
  @Output() init: EventEmitter<any> = new EventEmitter<any>();
  protected readonly environment = environment;
  public today: Date = new Date(); 

  constructor(public sync: SyncService, elRef: ElementRef, public request: RequestService) {
    super(elRef);
  }

  getStatus(request: any): string {
    return this.request.getStatusTheme(request)?.state || '';
  }
}
